import axios from "axios";
import { loginConfirmedAction, logout } from "../store/actions/AuthActions";

export function login(email, password) {
  const userData = {
    email,
    password,
  };
  return axios.post(`https://forex.server.sypto.xyz/api/admin/login`, userData);
}

export function saveTokenInLocalStorage(tokenDetails) {
  localStorage.setItem("userDetails", JSON.stringify(tokenDetails));
}

export function checkAutoLogin(dispatch, history) {
  const tokenDetailsString = localStorage.getItem("userDetails");
  let tokenDetails = "";
  if (!tokenDetailsString) {
    dispatch(logout(history));
    return;
  }
  if (tokenDetailsString) {
    tokenDetails = JSON.parse(tokenDetailsString);
  }
  dispatch(loginConfirmedAction(tokenDetails));
}
